import { render, staticRenderFns } from "./ReviewBlockSmall.vue?vue&type=template&id=590aa3d1"
import script from "./ReviewBlockSmall.vue?vue&type=script&lang=js"
export * from "./ReviewBlockSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports